/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".job-details li{margin-left:56px}.job-details .job-detail-property,.job-details ui-json-formatter:not(.expandable){margin-left:-28px;font-weight:700}.job-details ui-json-formatter.expandable{margin-left:-56px}.job-details ui-json-formatter .key{font-weight:700}.job-details ui-json-formatter .td-json-formatter-wrapper .td-object-children .td-key.td-key-leaf{padding-left:80px}.job-details ui-json-formatter ui-json-formatter.expandable{margin-left:0}"];
export { styles as styles };
